"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ListsManagement = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _AddNewListButton = require("./components/AddNewListButton");
var _List = require("./components/List");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ListsManagement = ()=>{
    const { translations, formatMessage } = (0, _useTranslations.useTranslations)();
    const { isValidating: loading, data: personalProductListsData } = (0, _hooks.useGetPersonalProductLists)();
    var _personalProductListsData_maximumAllowedRecords;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_presentationComponents.DashboardModule, {
        isIntro: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Header, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        variant: "h4",
                        component: "h4",
                        color: "textPrimary",
                        children: translations.productListOverviewPageTitle
                    }),
                    !loading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Description, {
                                color: "textPrimary",
                                children: formatMessage('productListOverviewPageDescription', {
                                    maxNumber: (_personalProductListsData_maximumAllowedRecords = personalProductListsData === null || personalProductListsData === void 0 ? void 0 : personalProductListsData.maximumAllowedRecords) !== null && _personalProductListsData_maximumAllowedRecords !== void 0 ? _personalProductListsData_maximumAllowedRecords : 5
                                })
                            }),
                            (personalProductListsData === null || personalProductListsData === void 0 ? void 0 : personalProductListsData.productLists.length) === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Description, {
                                color: "textPrimary",
                                children: translations.youDontHaveAnyList
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Body, {
                children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Loading, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AddNewListButton.AddNewListButton, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_List.List, {
                            items: personalProductListsData === null || personalProductListsData === void 0 ? void 0 : personalProductListsData.productLists
                        })
                    ]
                })
            })
        ]
    });
};
exports.ListsManagement = ListsManagement;
